//export抛出
export function setLocalStorageAndTime (key, value) {
    window.localStorage.setItem(key, JSON.stringify({ data: value, time: new Date().getTime() }))
}
export function getLocalStorageAndTime (key, exp = 86400000) {
    // 获取数据
    let data = window.localStorage.getItem(key)
    if (!data) return null
    let dataObj = JSON.parse(data)
    // 与过期时间比较
    if (new Date().getTime() - dataObj.time > exp) {
    // 过期删除返回null
    deleteLocalStorage(key)
    console.log('信息已过期')
    return null
    } else {
    return dataObj.data
    }
}
export function deleteLocalStorage(key){
    window.localStorage.removeItem(key)
}